var r,e;!function(r){r.Ok="ok",r.Exited="exited",r.Crashed="crashed",r.Abnormal="abnormal"}(r||(r={})),function(r){r.Ok="ok",r.Errored="errored",r.Crashed="crashed"}(e||(e={}));export{e as RequestSessionStatus,r as SessionStatus};
